import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { AdminOrganizationSubscriptionResponse } from '@utils/types/admin';

export const ADMIN_ORG_SUBSCRIPTION_QUERY_KEY = 'adminOrgSubscription';

/**
 * Hook to fetch an organization's subscription details
 *
 * GET /api/admin/on-prem/organizations/{id}/subscription
 *
 * Returns current plan, billing period, usage, and history
 */
export const useGetAdminOrganizationSubscription = (organizationId: string) => {
  const fetchSubscription = async () => {
    const url = `api/admin/on-prem/organizations/${organizationId}/subscription`;
    const response =
      await Axios.get<AdminOrganizationSubscriptionResponse>(url);
    return response.data;
  };

  return useQuery<AdminOrganizationSubscriptionResponse, AxiosError<BaseError>>(
    [ADMIN_ORG_SUBSCRIPTION_QUERY_KEY, organizationId],
    fetchSubscription,
    {
      enabled: !!organizationId,
      useErrorBoundary: false,
      staleTime: 5 * 60 * 1000
    }
  );
};
